<template>
  <span>
    <v-btn small outlined color="grey darken-1" :disabled="disabled" @click="open">
      <v-icon left small>mdi-history</v-icon>History
    </v-btn>
    <v-dialog v-model="isOpen" max-width="620" scrollable>
      <v-card>
        <v-card-title class="d-flex flex-row justify-space-between">
          <span>{{ title }} History</span>
          <v-btn icon @click="isOpen = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text style="max-height: 60vh;">
          <v-progress-linear v-if="loading" indeterminate class="mt-4"/>
          <div v-else-if="events.length === 0" class="py-8 text-center">No history has been recorded.</div>
          <v-timeline v-else dense class="ml-n6 mt-4">
            <v-timeline-item v-for="ev in events" :key="ev.logId" small fill-dot :color="style(ev.type).color" :icon="style(ev.type).icon">
              <div class="d-flex flex-column">
                <b>{{ ev.description }}</b>
                <span style="font-size: 13px;">{{ ev.userId ? lookupUsername(ev.userId) : 'System' }} at {{ utils.formatDate(ev.at, 'withTime') }}</span>
                <span v-if="ev.reason" style="font-size: 13px;"><b>Reason: </b>{{ ev.reason }}</span>
              </div>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import utils from '../plugins/helpers'

const STYLES = {
  created: {color: 'info', icon: 'mdi-plus'},
  sealed: {color: 'success', icon: 'mdi-check'},
  voided: {color: 'warning', icon: 'mdi-close'},
  unvoided: {color: 'teal', icon: 'mdi-undo'},
  deleted: {color: 'error', icon: 'mdi-delete'},
  restored: {color: 'teal', icon: 'mdi-restore'},
  status: {color: 'grey', icon: 'mdi-swap-horizontal'}
}

// Shows a document's history (created / sealed / voided / unvoided ...), newest first.
// url is the history endpoint without the server address, e.g. /api/orders/history/12
export default {
  name: 'DocumentHistoryDialog',
  props: {
    url: {type: String, required: true},
    title: {type: String, default: 'Document'},
    disabled: Boolean
  },
  data: () => ({
    isOpen: false,
    loading: false,
    events: [],
    utils: utils
  }),
  computed: {
    ...mapGetters(['getEndpoint', 'lookupUsername'])
  },
  methods: {
    style(type) {
      return STYLES[type] || STYLES.status
    },
    async open() {
      this.isOpen = true
      this.loading = true
      this.events = []
      try {
        let res = await axios.get(`${this.getEndpoint}${this.url}`)
        this.events = res.data.data.slice().reverse()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
